import { SET_REGENERATING_DOWNLOADS } from './types';

const initialState = {
  regeneratingDownloads: false,
};

interface IState {
  regeneratingDownloads: boolean;
}

export default (
  state: IState = initialState,
  action: {
    regeneratingDownloads?: boolean;
    type: string;
  }
): IState => {
  if (action.type === SET_REGENERATING_DOWNLOADS) {
    if (action.regeneratingDownloads === undefined) {
      return state;
    }

    return { ...state, regeneratingDownloads: action.regeneratingDownloads };
  }

  return state;
};
